import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { SharedService } from '../../../../../shared/services/shared.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-membership-you',
  imports: [TranslateModule, CommonModule, ButtonComponent],
  templateUrl: './membership-you.component.html',
  styleUrl: './membership-you.component.scss'
})
export class MembershipYouComponent {
  @Input() userDetail: any;
  @Input() accessableServices: any;
  @Input() userAccessData: any;
  @Input() contacts: any[] = [];
  @Output() unlinkUser = new EventEmitter<any>();

  constructor(private sharedService: SharedService) { }

  unLinkMember() {
    const adminFlag = String(this.userAccessData?.['DC Admin Flag'] ?? '').trim().toUpperCase();
    const isCurrentUserAdmin = adminFlag === 'Y' || adminFlag === '';

    if (isCurrentUserAdmin) {
      const currentLoginName = String(this.userDetail?.['Login Name'] ?? '').trim().toLowerCase();
      const hasAnotherAdmin = Array.isArray(this.contacts) && this.contacts.some((contact: any) => {
        const contactLoginName = String(contact?.['Login Name'] ?? '').trim().toLowerCase();
        const contactAdminFlag = String(contact?.['DC Admin Flag'] ?? '').trim().toUpperCase();
        return contactAdminFlag === 'Y' && contactLoginName !== currentLoginName;
      });

      if (!hasAnotherAdmin) {
        this.sharedService.toastMessage(
          'ERROR',
          'MAKE_USER_ADMIN',
          'error',
          true
        );
        return;
      }
    }
    this.unlinkUser.emit();
  }
}
